// extracted by mini-css-extract-plugin
export default {"Header":"LetsStart_Header__XiIIP","links":"LetsStart_links__Jh2yV","navlink":"LetsStart_navlink__r4XJc","Mobilenavlink":"LetsStart_Mobilenavlink__x+rif"};